import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { BarChart3 } from 'lucide-react';

interface DevelopmentHighlightsProps {
  /** Custom styling for the container */
  className?: string;
  /** Whether to use admin-specific styling */
  adminView?: boolean;
}

export const DevelopmentHighlights: React.FC<DevelopmentHighlightsProps> = ({ 
  className = "",
  adminView = false
}) => {
  return (
    <Card className={`bg-gradient-to-r from-slate-50 to-slate-100 border-slate-200 ${className}`}>
      <CardContent className={adminView ? "p-6" : "p-4 sm:p-6"}>
        <div className="flex items-center gap-3 mb-4">
          <div className={`p-2 rounded-lg flex-shrink-0 ${
            adminView ? 'bg-primary/10' : 'bg-primary/10'
          }`}>
            <BarChart3 className={`h-5 w-5 ${
              adminView ? 'text-primary' : 'text-primary'
            }`} />
          </div>
          <h3 className="text-lg font-semibold">Development Highlights</h3>
        </div>
        
        <div className={`grid gap-4 ${adminView ? 'md:grid-cols-2' : 'md:gap-6 sm:grid-cols-2'}`}>
          <div>
            <p className="text-sm font-medium mb-2">Recent Focus Areas:</p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• HivePad task management and productivity tools</li>
              <li>• AI-powered billing assistance and analytics</li>
              <li>• Video management and streaming capabilities</li>
              <li>• Electronic signatures and form automation</li>
            </ul>
          </div>
          <div>
            <p className="text-sm font-medium mb-2">Platform Evolution:</p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• 123+ custom React hooks for performance</li>
              <li>• Material Design system implementation</li>
              <li>• Comprehensive accessibility compliance</li>
              <li>• Mobile-first responsive design overhaul</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-4 pt-4 border-t border-slate-200">
          <p className="text-sm text-muted-foreground">
            <strong>8 months of innovation:</strong> From December 2024 to July 2025, we've delivered consistent 
            improvements to make Hivetivity the most powerful youth program management platform available.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};